import {useUserStore} from '~/store/userStore.js'

export default defineNuxtPlugin(async () => {
    const userStore = useUserStore()

    if (!userStore.token) {
        return
    }

    try {
        await userStore.fetchUser()
    } catch {
        // guest / expired token
    }
})
